var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-footer",
    {
      staticClass: "footer justify-center align-bottom",
      class: { "pt-7": _vm.paddedTop, "pb-7": _vm.paddedBottom },
      attrs: { app: _vm.fixed, color: "navy darken-1" },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex white--text" },
        [
          _c("div", [
            _vm._v("\n      © 2026 - Dai laboratori di\n      "),
            _c(
              "a",
              {
                staticClass: "secondary--text text-decoration-none",
                attrs: { href: _vm.host_fantapazz, target: "_blank" },
              },
              [_vm._v("fantapazz.com")]
            ),
            _vm._v("\n      con\n    "),
          ]),
          _vm._v(" "),
          _c(
            "v-icon",
            { staticClass: "ml-1 error--text", attrs: { "x-small": "" } },
            [_vm._v("favorite")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }